/**获取小数点后有效数字
 * @param { String | Number } data - 数值
 * @param { Number } number - 有效位数
 * @param { Boolean } zero - 存在小数点并且未达到有效位数时, 补0到达有效位数
 * @returns { String }
 */
export const validFigure = (data: any, number: number, zero?: boolean) => {
    //* 检测是否为一个数字
    if (data == 0 || isNaN(data)) return 0;

    //* 数据初始化
    const strings = data.toString().split(".");
    const numberLast = strings[1];
    const numberFirst = strings[0];

    //* 如果number<=0 or 不存在小数点, 则直接返回数值
    if (!numberLast || number <= 0) return numberFirst;

    //* 数据初始化
    const result = { number: 0, data: [] as string[] };
    const decimals = numberLast.split("");
    for (let i = 0; i < decimals.length; i++) {
        //* 检测有效数字获取完成
        if (result.number == number) return result.number > 0 ? `${numberFirst}.${result.data.join("")}` : numberFirst;
        //* 检测是否为有效数字
        if (decimals[i] && decimals[i] != 0) result.number++;
        //* 数据添加
        result.data.push(decimals[i]);
    }

    //* 检测是否补0
    if (zero) {
        for (let i = 0; i < number - result.number; i++) {
            result.data.push("0");
        }
    }

    return `${numberFirst}.${result.data.join("")}`;
};
